import * as types from "./mutations-type";
export default{
    [types.SET_MSG](state,payload){
        state.msg = payload
    },
    [types.SET_EDITAR](state,payload){
       
        state.editar = payload
    },
    [types.SET_LISTA](state,payload){
        state.lista = payload
    },
    [types.SET_PESQUISA](state,payload){
        state.pesquisa = payload
    },
    [types.SET_BOLETINS](state,payload){
        state.boletins = payload
    },
    [types.SET_TAXAS](state,payload){
        state.taxas = payload
    },
    [types.SET_FATURA_ID](state,payload){
        state.fatura_id = payload
    },
    [types.SET_RUBLICAS](state,payload){
        state.rublucas = payload
    },
    [types.SET_TRABALHADORES](state,payload){
        state.trabalhadores = payload
    },
}